export default __webpack_public_path__ + "static/media/entrance_3_1.0ce2ac39.png";